import { useContext } from "react";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { ITagValue } from "../../common/models/ITagValue";
import { ITagRegisterInfo } from "../../services/properties-data-service/Models";
import { LiveDataContext } from "./LiveDataContext";
import { LiveDataState, LiveDataStateItem } from "./LiveDataContextTypes";

export function useLiveDataContext() {
    const context = useContext<[LiveDataState,
        (contextObject: IeLynxObject) => LiveDataStateItem | undefined, // get active status
        (contextObject: IeLynxObject, writeOnly?: boolean) => Promise<void>, // demand scan
        (contextObject: IeLynxObject) => Promise<void>, // cancel command
        (contextObject: IeLynxObject, values: ITagValue[]) => Promise<void>,
        (registerInfo: ITagRegisterInfo) => Promise<void>, // test change register
        (contextObject: IeLynxObject) => Promise<void>,
        (pollingServer: string, acmObjectName: string, elynxObject: IeLynxObject) => Promise<void>, // get polling stats
    ] | undefined>(LiveDataContext);
    if (!context) {
        throw new Error("useLiveDataContext must be used within an LiveDataContextProvider");
    }
    return context;
}
